import Image from 'next/image';
import { forwardRef } from 'react';
import cn from 'classnames';

import s from './card.module.scss';

type CardProps = {
  quote: string;
  author: {
    image: {
      src: string;
      width: number;
      height: number;
    };
    fullName: string;
    position: string;
    event: string;
  };
  className?: string;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(({ quote, author, className }, ref) => {
  return (
    <div className={cn(className, s.card)} ref={ref}>
      <Image
        src={author.image.src}
        width={author.image.width}
        height={author.image.height}
        alt={author.fullName}
        quality={100}
        className={s['card__image']}
      />

      <div className={s['quote__wrapper']}>
        <q className={s.quote}>{quote}</q>

        <div className={s['quote__author']}>
          <p className={s['quote-author__name']}>{author.fullName}</p>
          <p className={s['quote-author__position']}>
            - {author.position}
            <br />
            {author.event}
          </p>
        </div>
      </div>
    </div>
  );
});
